import { useFormDataContext } from "@totalenergiescode/mobility-business-rev-form-data/components";
import { memo } from "react";

import { StyledStepTitle } from "@/components/FormData/lib/layout/Renderers/styles.ts";
import TranslationFailureIndicator from "@/components/FormData/lib/layout/Renderers/TranslationFailureIndicator.tsx";

import NavigationRenderer from "./NavigationRenderer.tsx";
import SectionRenderer from "./SectionRenderer";

interface StepRendererProps {
  stepNumber: number;
}

function StepRenderer({ stepNumber }: Readonly<StepRendererProps>) {
  const { findStepByNumber, translator, translatorFor } = useFormDataContext();

  const step = findStepByNumber(stepNumber);

  return (
    <div>
      <StyledStepTitle variant='title5'>{`${translatorFor(step).with(step).title()}`}</StyledStepTitle>
      <TranslationFailureIndicator targetId={step} />

      {step.hasAtLeastOneFieldToBeDisplayed() ? (
        step.sections
          .filter((item) => item.mustBeDisplayed())
          .map((section) => (
            <SectionRenderer
              key={`section-${section.number}`}
              section={section}
              translator={translator}
            />
          ))
      ) : (
        <div>{translator.translate("noFields")}</div>
      )}

      <NavigationRenderer />
    </div>
  );
}

export default memo(StepRenderer);
